import React from "react";
import "./ScrollableTable.css";
import "./../../index.css";
import { nameInitials } from "../../utils/helper";

const ScrollableTable = (props) => {

    const { row, columns, showNameTumbnail } = props;
    // console.log("rows", row, columns);
    
    return (
        <div className="scrollable-table-container">
            <table>
                <thead>
                    <tr>
                        {/* <th className="text-sm text-color sticky-col"></th> */}

                        {
                            row && row.length > 0  ? row.map((title, index) =>(
                                <th key={ Math.random() + index } className="text-sm text-color">{ title }</th>
                            )) : null
                        }
                    </tr>
                </thead>

                <tbody>
                    {
                        columns.map((colData, parentIndex) => (
                            <tr key={ Math.random() + parentIndex }>
                                <td key={ Math.random() + parentIndex * 2 } className="text-sm text-color sticky-col">
                                    <div className="flex items-center">
                                        { 
                                            showNameTumbnail && ( <div className="name-thumbnail mr-2" style={ { backgroundColor: `#${Math.floor(Math.random() * 16777215).toString(16).padStart(6, '0')}` } }>{ nameInitials(colData.full_name) }</div> )
                                        }

                                        { colData.full_name }
                                    </div>

                                </td>
                                {
                                    colData.data.map((childData, childIndex) =>{
                                        return Object.entries(childData).map(([key, value], dataIndex) =>(
                                            <td key={ Math.random() + childIndex + dataIndex } className="text-sm text-color">
                                                {/* { value } */}

                                                <div className="flex items-center">
                                                    <div>{ value } </div>
                                                </div>
                                            </td>
                                        ))
                                    })
                                }
                            </tr>
                        ))
                    }
                </tbody>
            </table>
        </div>
    )
}

export default React.memo(ScrollableTable);